export default __webpack_public_path__ + "static/consultationBg1-3819b54fe9858aeca50863705a2d0cff.png";